import { render, staticRenderFns } from "./AirportDetails.vue?vue&type=template&id=663cb784"
import script from "./AirportDetails.vue?vue&type=script&lang=js"
export * from "./AirportDetails.vue?vue&type=script&lang=js"
import style0 from "./AirportDetails.vue?vue&type=style&index=0&id=663cb784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports